const getBuildHash = () => `v=${Date.now()}`;
(window as any).getBuildHash = getBuildHash;

import('./bootstrap');

export {};
